import * as req from 'api/actions';
import * as c from './constant';

export const getGradeLevelList = (payload, callback) =>
  req.list(
    c.GET_GRADE_LEVELS,
    'api/v1/administrators/social_amelioration_citizens/settings/educational_grade_levels',
    payload,
    callback
  );

export const showGradeLevel = (id, payload, callback) =>
  req.item(
    c.SHOW_GRADE_LEVEL,
    `api/v1/administrators/social_amelioration_citizens/settings/educational_grade_levels/${id}`,
    payload,
    callback
  );

export const updateGradeLevel = (id, payload, callback) =>
  req.update(
    c.UPDATE_GRADE_LEVEL,
    `api/v1/administrators/social_amelioration_citizens/settings/educational_grade_levels/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearGradeLevel = () => req.setList(c.GET_GRADE_LEVELS, []);

export const createGradeLevel = (payload, callback) =>
  req.create(
    c.CREATE_GRADE_LEVEL,
    `api/v1/administrators/social_amelioration_citizens/settings/educational_grade_levels`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeGradeLevel = (id, payload, callback) =>
  req.remove(
    c.REMOVE_GRADE_LEVEL,
    `api/v1/administrators/social_amelioration_citizens/settings/educational_grade_levels/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
